import { defineVersions } from '../../helpers/define-versions';

export const HEADING_VERSIONS = defineVersions({
  component: 'Heading',
  current: '2.2',
  previous: '2.1',
  // Unversioned call sites keep rendering the old version until you deliberately flip this.
  // The themes' `component-styles/heading/index.ts` carries the same value as
  // `defaultVersion`, for elements imported straight from `@chakra-ui/react` that never
  // reach the dispatcher. Flip both together; `heading-versioning.spec.ts` enforces it.
  default: '2.1',
});
